module.exports = __webpack_public_path__ + "img/13-3.671c5dbf.png";